import api from 'api'

export type LinkVndlyPositionParams = {
  vndlyInstanceId: number
  companyPositionId: number
  vndlyJobTitle: string
}

export type LinkVndlyPositionResponse = {
  id: number
}

export const linkVndlyPosition = async (
  params: LinkVndlyPositionParams
): Promise<LinkVndlyPositionResponse> => {
  const result = await api.post<LinkVndlyPositionResponse>(
    '/admin/vndly/positions/link',
    params
  )
  return result.data
}
